import {toast, ToastContainer} from "react-toastify";
import React, {useEffect, useState} from "react";
import TopAdminBar from "../../components/TopAdminBar";
import { Col, Container, Row } from "react-bootstrap";
import "./SettingsStyle.css";
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";
import Confirm from "../../components/Confirm";
import Footer from "../../components/Footer";
import {GET, request, POST, PUT} from "../../api/ApiAdapter";
import {useHistory} from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";

const Settings = () => {

    const  ZebraBrowserPrintWrapper = require('zebra-browser-print-wrapper');
    const [printerList, setPrinterList] = useState([]);
    const [printerIndex, setPrinterIndex] = useState();
    const [confirmMsg, setConfirmMsg] = useState(false);
    const [isPendingSend, setIsPendingSend] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [showCalibrateModal, setShowCalibrateModal] = useState(false);
    const [showFactoryResetModal, setShowFactoryResetModal] = useState(false);

    const [email, setEmail] = useState('');
    const [emailList, setEmailList] = useState([]);
    const [error, setError] = useState('');
    const [isTextMail, setIsTextMail] = useState(true);
    const [isXmlMail, setIsXmlMail] = useState(false);
    const [isLoadingModes, setIsLoadingModes] = useState(true);

    const calibrateZPL = `^XA\n^JUN\n^MNA\n^MTT\n^PR5\n^MD27\n^LL1218\n^PW812\n^XZ\n~JC\n^XA\n^FO0,0^GB812,1218,4^FS\n^CF0,60\n^FO50,50^FDTEST LABEL^FS\n^CF0,40\n^FO50,150^FDWindshield Printer OK^FS\n^FO50,200^FD4\" x 6\" Calibration Test^FS\n^FO50,250^FDDate: 2025-09-05^FS\n^FO50,300^FDSpeed: 5 IPS  Darkness: 27^FS\n^XZ`;
    const factoryResetZPL = `^XA\n^JUF\n^XZ`;

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setError('');
    };

    const handleAddEmail = () => {
        if (email && validateEmail(email)) {
            setEmailList([...emailList, email]);
            setEmail('');
            setError('');
            // updateEmailList();
        } else {
            setError('Please enter a valid email address.');
        }
    };

    const validateEmail = (email) => {
        // Basic email validation regex
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const history = useHistory();

    // Create a new instance of the object
    const browserPrint = new ZebraBrowserPrintWrapper.default();

    const onInputPrinterChange = async (e) => {
        console.log("Removed previous printer");
        localStorage.removeItem('printer');

        console.log("Selector Printer - ", printerList[e.target.value]);
        localStorage.setItem('printer', JSON.stringify(printerList[e.target.value]));
        selectPrinterIndex(printerList);
    }

    const selectPrinterIndex = (printers) =>{
        const printerSelect = JSON.parse(localStorage.getItem('printer'));
        if (printerSelect !== null){
            printers.forEach((print) => {
                if (printerSelect.name === print.name) {
                    setPrinterIndex(printers.indexOf(print));
                }
            });
        }
    }

    let allPrinters;
    const getPrintersList = async () =>{
        // Select all available printer
        allPrinters = await browserPrint.getAvailablePrinters();
        setPrinterList(allPrinters);
        console.log("Printers List - ", allPrinters);

        if(allPrinters.length > 0){
            toast.info("Printers are loaded");
            selectPrinterIndex(allPrinters);
        } else{
            toast.error("Error: No printers available");
            localStorage.removeItem('printer');
        }
    }

    const loadPendingLabelsAvailability = async () => {
        try {
            let result = await request("prints/receive/pendingLabels", GET);
            if (!result.error) {
                setIsPendingSend(result);
            }
            else {
                if (result.error.response !== undefined && result.error.response.status === 401) {
                    history.push("/page/login");
                } else {
                    toast.error(result.error.message);
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    const loadSmsEmailList = async () => {
        try {
            let result = await request("accounts/smsemails", GET);
            if (!result.error) {
                if(result) setEmailList(result);
            }
            else {
                if (result.error.response !== undefined && result.error.response.status === 401) {
                    history.push("/page/login");
                } else {
                    toast.error(result.error.message);
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            setIsInitialLoad(false);
        }
    };

    const updateEmailList = async () => {
        try {
            console.log(emailList);
            let result = await request("accounts/smsemails", PUT, JSON.stringify(emailList), {
            headers: {
                'Content-Type': 'application/json',
            },
            });
            if (!result.error) {
                toast.success("Account SMS Email List Updated Successfully");
            } else {
                toast.error(result.error.message);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleDeleteEmail = (emailToDelete) => {
        setEmailList((prevEmailList) => prevEmailList.filter(email => email !== emailToDelete));
    };

    const loadEmailModes = async () => {
        try {
            let result = await request("accounts/emailmodes", GET);
            if (!result.error) {
                setIsTextMail(result.isTextMail ?? true);
                setIsXmlMail(result.isXmlMail ?? false);
            } else {
                if (result.error.response !== undefined && result.error.response.status === 401) {
                    history.push("/page/login");
                } else {
                    toast.error(result.error.message);
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoadingModes(false);
        }
    };

    const updateEmailModes = async (textMailValue, xmlMailValue) => {
        try {
            let result = await request("accounts/updateEmailmodes", PUT, JSON.stringify({
                isTextMail: textMailValue,
                isXmlMail: xmlMailValue
            }), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (!result.error) {
                toast.success("Email modes updated successfully");
            } else {
                toast.error(result.error.message);
                setIsTextMail(!textMailValue);
                setIsXmlMail(!xmlMailValue);
            }
        } catch (e) {
            console.log(e);
            toast.error("Failed to update email modes");
            setIsTextMail(!textMailValue);
            setIsXmlMail(!xmlMailValue);
        }
    };

    const sendPendingLabelsAvailability = async (availability) => {
        try {
            let result = await request(`prints/send/pendingLabels/${availability}`, POST, {});
            if (!result.error) {
                toast.success("Pending labels email sending successfully " + (availability ? "enabled" : "disabled"));
            } else {
                toast.error(result.error.message);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleSendingEmails = (e) => {
        setIsPendingSend(e.target.checked);
        sendPendingLabelsAvailability(e.target.checked);
    };

    const handleCalibrateClick = () => {
        setShowCalibrateModal(true);
    };

    const handleCalibrateConfirm = async () => {
        setShowCalibrateModal(false);
        const printerSelect = JSON.parse(localStorage.getItem('printer'));
        if (printerSelect) {
            await browserPrint.setPrinter(printerSelect);
            browserPrint.print(calibrateZPL);
            toast.success('Calibration ZPL sent to printer');
        } else {
            toast.error('No printer selected');
        }
    };

    const handleCalibrateCancel = () => {
        setShowCalibrateModal(false);
    };

    const handleFactoryResetClick = () => {
        setShowFactoryResetModal(true);
    };

    const handleFactoryResetConfirm = async () => {
        setShowFactoryResetModal(false);
        const printerSelect = JSON.parse(localStorage.getItem('printer'));
        if (printerSelect) {
            await browserPrint.setPrinter(printerSelect);
            browserPrint.print(factoryResetZPL);
            toast.success('Factory Reset ZPL sent to printer');
        } else {
            toast.error('No printer selected');
        }
    };

    const handleFactoryResetCancel = () => {
        setShowFactoryResetModal(false);
    };

    const handleTextMailChange = (e) => {
        const isChecked = e.target.checked;
        
        if (isChecked) {
            setIsTextMail(true);
            setIsXmlMail(false);
            updateEmailModes(true, false);
        } else {
            if (!isXmlMail) {
                toast.warning("At least one email mode must be selected!");
                e.target.checked = true;
                return;
            }
            setIsTextMail(false);
            updateEmailModes(false, true);
        }
    };

    const handleXmlMailChange = (e) => {
        const isChecked = e.target.checked;
        
        if (isChecked) {
            setIsXmlMail(true);
            setIsTextMail(false);
            updateEmailModes(false, true);
        } else {
            if (!isTextMail) {
                toast.warning("At least one email mode must be selected!");
                e.target.checked = true;
                return;
            }
            setIsXmlMail(false);
            updateEmailModes(true, false);
        }
    };

    useEffect(() => {
        getPrintersList();
        loadPendingLabelsAvailability();
        loadSmsEmailList();
        loadEmailModes();
    },[])

    useEffect(() => {
        if (!isInitialLoad) updateEmailList();
    },[emailList])


    //========Check Print Agent Availability==========//

    const refreshPage =  () => {
        window.location.reload(false);
    }

    const checkAgentAvailability = async () => {
        await browserPrint.getAvailablePrinters().then((res) => {
            localStorage.removeItem('agentNotActive');
            setConfirmMsg(false);
            console.log("Agent not available - ",JSON.parse(localStorage.getItem('agentNotActive')));

        }).catch(error => {
                toast.error("Zebra Browser Print not found");
                localStorage.setItem('agentNotActive', JSON.stringify(true));
                setConfirmMsg(JSON.parse(localStorage.getItem('agentNotActive')));
                console.log("Agent not available - ",JSON.parse(localStorage.getItem('agentNotActive')));
            });
    }

    // useEffect(() => {
    //     checkAgentAvailability();
    // }, []);

    //========Check Print Agent Availability==========//

    // Custom modal for Calibrate Media confirmation
    const CalibrateModal = ({ open, onConfirm, onCancel }) => {
        if (!open) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50">
                <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                    <h2 className="text-xl font-bold mb-4 text-green-700">Calibrate Media</h2>
                    <p className="mb-6 text-gray-700">Are you sure you want to calibrate media for the selected printer?</p>
                    <div className="flex justify-end gap-3">
                        <button
                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                            onClick={onConfirm}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // Custom modal for Factory Reset confirmation
    const FactoryResetModal = ({ open, onConfirm, onCancel }) => {
        if (!open) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50">
                <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                    <h2 className="text-xl font-bold mb-4 text-red-700">Factory Reset</h2>
                    <p className="mb-6 text-gray-700">Are you sure you want to factory reset the selected printer? This will wipe all printer settings.</p>
                    <div className="flex justify-end gap-3">
                        <button
                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
                            onClick={onConfirm}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return(
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='colored'
            />
            <div className="bg-white h-screen">
                <TopAdminBar/>
                <div className="ml-64 top-1 mt-6 left-0 flex items-center overflow-auto">
                    <Container className="mr-10 mt-6 mb-24">
                        <Row>
                            <Col xs={3}></Col>
                            <Col xs={6}>
                                <div><b className="text-lg mt-20">Printer Settings</b></div>
                                <div className="mt-3">
                                    <form
                                        method="post"
                                        action="/instrumentType"
                                        encType="multipart/form-data"
                                    >
                                        <div className="col-span-6 sm:col-span-3 flex items-center gap-4">
                                            <label
                                                htmlFor="role"
                                                className="block mt-1 text-sm font-medium text-gray-700 pr-4"
                                            >
                                                Printer
                                            </label>
                                            <select
                                                name="selected_printer"
                                                id="selected_printer"
                                                value={printerIndex}
                                                onChange={(e) => onInputPrinterChange(e)}
                                                className="outline-none focus:ring-green-500 focus:border-green-500 block shadow-sm sm:text-sm rounded-md p-2 bg-gray-100 text-gray-700"
                                            >
                                                <option disabled selected defaultChecked>
                                                    Choose Printer Here
                                                </option>
                                                {printerList.length > 0 ?
                                                    printerList.map((item, key) => {
                                                        return (
                                                            <option value={key} key={key}>
                                                                {item.name}
                                                            </option>
                                                        );
                                                    })
                                                    : null
                                                }
                                            </select>
                                            <button
                                                type="button"
                                                className={printerIndex !== undefined ?
                                                    "ml-2 bg-green-500 hover:bg-green-600 text-white rounded p-2 sm:text-sm flex items-center" :
                                                    "ml-2 bg-gray-400 text-white rounded p-2 sm:text-sm flex items-center cursor-not-allowed"
                                                }
                                                style={{height: '40px'}}
                                                onClick={handleCalibrateClick}
                                                disabled={printerIndex === undefined}
                                            >
                                                Calibrate Media
                                            </button>
                                            <button
                                                type="button"
                                                className={printerIndex !== undefined ?
                                                    "ml-2 bg-red-500 hover:bg-red-600 text-white rounded p-2 sm:text-sm flex items-center" :
                                                    "ml-2 bg-gray-400 text-white rounded p-2 sm:text-sm flex items-center cursor-not-allowed"
                                                }
                                                style={{height: '40px'}}
                                                onClick={handleFactoryResetClick}
                                                disabled={printerIndex === undefined}
                                            >
                                                Factory Reset
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="text-lg mt-10"><b>Email Settings</b></div>
                                <div className="flex mt-3 mb-3">
                                    <label
                                        htmlFor="sendemail"
                                        className=" text-sm font-medium text-gray-700"
                                    >
                                        Send Pending Emails
                                    </label>
                                    <input
                                        type="checkbox"
                                        checked={isPendingSend}
                                        onChange={(e) =>
                                            handleSendingEmails(e)
                                        }
                                        className="ml-3 shadow-sm sm:text-sm rounded-md bg-gray-100"
                                    />
                                </div>

                                <div className="text-lg mt-10"><b>Email Format Settings</b></div>
                                <div className="mt-3">
                                    <div className="flex items-center gap-6">
                                        <div className="flex items-center">
                                            <label
                                                htmlFor="textMail"
                                                className="text-sm font-medium text-gray-700 mr-3"
                                            >
                                                Text
                                            </label>
                                            <input
                                                type="checkbox"
                                                id="textMail"
                                                checked={isTextMail}
                                                onChange={handleTextMailChange}
                                                disabled={isLoadingModes}
                                                className="shadow-sm sm:text-sm rounded-md bg-gray-100 w-4 h-4"
                                            />
                                        </div>
                                        
                                        <div className="flex items-center">
                                            <label
                                                htmlFor="xmlMail"
                                                className="text-sm font-medium text-gray-700 mr-3"
                                            >
                                                XML
                                            </label>
                                            <input
                                                type="checkbox"
                                                id="xmlMail"
                                                checked={isXmlMail}
                                                onChange={handleXmlMailChange}
                                                disabled={isLoadingModes}
                                                className="shadow-sm sm:text-sm rounded-md bg-gray-100 w-4 h-4"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="text-lg mt-10"><b>SMS Details Email List</b></div>
                                <div className="mt-3">
                                    <input
                                    type="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    placeholder="Enter email"
                                    className="border px-2 py-1 mr-2 w-72"
                                    />
                                    <button onClick={handleAddEmail} className="bg-blue-500 text-white px-4 py-1">
                                    Add Email
                                    </button>
                                </div>
                                {error && <p className="text-red-500 mt-2 text-xs">{error}</p>}

                                <ul className="email-list">
                                    {emailList.map((email, index) => (
                                    <li key={index} className="email-list-item">
                                        {email}
                                        <button
                                            className="delete-btn"
                                            onClick={() => handleDeleteEmail(email)}
                                        >
                                            <i className="fas fa-trash-alt"><MdDeleteForever /></i>
                                        </button>
                                    </li>
                                    ))}
                                </ul>
                            </Col>
                            <Col xs={3}></Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
            {confirmMsg ? (
                <Confirm
                    onConfirm={refreshPage}
                />
            ) : null}
            {showCalibrateModal && (
                <CalibrateModal
                    open={showCalibrateModal}
                    onConfirm={handleCalibrateConfirm}
                    onCancel={handleCalibrateCancel}
                />
            )}
            {showFactoryResetModal && (
                <FactoryResetModal
                    open={showFactoryResetModal}
                    onConfirm={handleFactoryResetConfirm}
                    onCancel={handleFactoryResetCancel}
                />
            )}
        </>
    );
}

export default Settings;
